
import { db, doc, getDoc } from "../../firebaseClient";
import { ApprovalFlow } from "../types/approval";

export interface ReadOnlyApprovalStatus {
  hasFlow: boolean;
  flowId?: string;
  status: string; // From flow
  currentStageLabel: string;
  currentStageKey: string;
  lastUpdated?: string;
  isTerminal: boolean;
}

export async function fetchReadOnlyApprovalStatus(
  module: string,
  docId: string,
  docCode?: string
): Promise<ReadOnlyApprovalStatus> {
  // Logic to probe potential Flow IDs
  // Priority: 
  // 1. Standard: {module}_{docId}
  // 2. Legacy Contract: CONTRACT_REVIEW_{docId}
  // 3. DocCode variants (if code exists)
  
  const candidates = [
    `${module}_${docId}`,
    docCode ? `${module}_${docCode}` : null,
    module === 'contractDraft' ? `CONTRACT_REVIEW_${docId}` : null,
    (module === 'contractDraft' && docCode) ? `CONTRACT_REVIEW_${docCode}` : null
  ].filter(Boolean) as string[];

  // Remove duplicates
  const uniqueCandidates = Array.from(new Set(candidates));

  for (const id of uniqueCandidates) {
    try {
        const snap = await getDoc(doc(db, "approvalFlows", id));
        if (snap.exists) {
          const flow = snap.data() as ApprovalFlow;
          const isTerminal = ["APPROVED", "FULLY_APPROVED", "REJECTED", "RETURNED", "LEGAL_RETURNED", "COMPLETED", "CANCELLED"].includes(flow.status);
          
          // Derive Stage Label
          let label = "處理中";
          if (isTerminal) {
              if (flow.status.includes("APPROVED")) label = "流程完成";
              else if (flow.status.includes("REJECTED")) label = "已駁回";
              else if (flow.status.includes("RETURNED")) label = "已退回";
              else label = flow.status;
          } else {
              const active = flow.stages?.find(s => s.key === flow.currentStageKey) 
                          || flow.stages?.find(s => s.status === 'PENDING' || (s.status as string) === 'IN_REVIEW');
              if (active) label = active.label;
          }

          return {
            hasFlow: true,
            flowId: id,
            status: flow.status,
            currentStageLabel: label,
            currentStageKey: flow.currentStageKey || "UNKNOWN",
            lastUpdated: flow.updatedAt?.toDate?.()?.toISOString() || new Date().toISOString(),
            isTerminal
          };
        }
    } catch (e) {
        console.warn(`[ReadOnlyView] Error fetching flow ${id}`, e);
    }
  }

  return { 
      hasFlow: false, 
      status: "MISSING_FLOW", 
      currentStageLabel: "(未連結流程)", 
      currentStageKey: "NONE", 
      isTerminal: false 
  };
}

